import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1mmh6abszb4gw">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="1hph2y8nikfth">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="ty1vk1gvr8bd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="u0xvtwg7a92z">
            Fedezd fel a teljes <em className="text-red-300" data-id="element-230" data-mp="13x17bswxzk2l">ÉNEK-ZENE KÉSZ™</em> csomagot
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="13uy8cjdtaglq">
            Egy teljes tanév ének-zene órái – készen, mindössze 5 perc alatt.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="2famrt0ruwxhs" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="2affss69j8gz7">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-234" data-mp="ui8ze7qxcmlg">A teljes csomag tartalma</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-235" data-mp="zjg6e4l8thr2">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-236" data-mp="13ip0xbo3xjno">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-237" data-mp="6tzdz6xmi0uu">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="bs12i7dtisdp" />
                </span>
                <span data-id="element-239" data-mp="ftm9xd7l2egi">
                  <span className="block font-medium leading-snug" data-id="element-240" data-mp="fsb3t6qo0um8">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-241" data-mp="kmp7dwfhe81z">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-242" data-mp="3o9fp9oq6hjvz">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-243" data-mp="vdwdar3hdqpp">Bevezető ár</p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-244" data-mp="qg4hhlzptkg8">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-245" data-mp="105xjpwdywn7t">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="cg397lh4faqq" />
            Egyszeri fizetés. Nincs előfizetés.
          </p>

          <CtaButton label="Kérem a teljes csomagot" className="mt-8 w-full" data-id="element-247" data-mp="7jcv33ovmp7y" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-248" data-mp="limaw2967hbe">
            {offerIncludes.map(item => <li key={item} data-id="element-249" data-mp="hi2b0qx7pzlk">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}